export const MESSAGES = {
  JOB_OFFER: {
    GET_ALL_SUCCESS: 'Ofertas de empleo obtenidas con éxito',
    GET_ALL_ERROR: 'Error al obtener las ofertas de empleo',
    GET_SUCCESS: 'Oferta de empleo obtenida con éxito',
    GET_ERROR: 'Error al obtener la oferta de empleo',
    CREATE_SUCCESS: 'Oferta de empleo creada con éxito',
    CREATE_ERROR: 'Error al crear la oferta de empleo',
    UPDATE_SUCCESS: 'Oferta de empleo actualizada con éxito',
    UPDATE_ERROR: 'Error al actualizar la oferta de empleo',
    DELETE_SUCCESS: 'Oferta de empleo eliminada con éxito',
    DELETE_ERROR: 'Error al eliminar la oferta de empleo',
    CLOSE_SUCCESS: 'Oferta de empleo cerrada con éxito',
    CLOSE_ERROR: 'Error al cerrar la oferta de empleo',
  },
  JOBTITLE: {
    GET_ALL_SUCCESS: 'Títulos de empleo obtenidos con éxito',
    GET_ALL_ERROR: 'Error al obtener los títulos de empleo',
    GET_SUCCESS: 'Título de empleo obtenido con éxito',
    GET_ERROR: 'Error al obtener el título de empleo',
    CREATE_SUCCESS: 'Título de empleo creado con éxito',
    CREATE_ERROR: 'Error al crear el título de empleo',
    UPDATE_SUCCESS: 'Título de empleo actualizado con éxito',
    UPDATE_ERROR: 'Error al actualizar el título de empleo',
    DELETE_SUCCESS: 'Título de empleo eliminado con éxito',
    DELETE_ERROR: 'Error al eliminar el título de empleo',
  },
  JOBTYPE: {
    GET_ALL_SUCCESS: 'Tipos de empleo obtenidos con éxito',
    GET_ALL_ERROR: 'Error al obtener los tipos de empleo',
    UPDATE_SUCCESS: 'Tipo de empleo actualizado con éxito',
    UPDATE_ERROR: 'Error al actualizar el tipo de empleo',
    CREATE_SUCCESS: 'Tipo de empleo creado con éxito',
    CREATE_ERROR: 'Error al crear el tipo de empleo',
  },
  BUSINESSLINE: {
    GET_ALL_ERROR: 'Error al obtener las líneas de negocio',
    CREATE_ERROR: 'Error al crear línea de negocio',
    CREATE_SUCCESS: 'Línea de negocio creada correctamente',
    UPDATE_ERROR: 'Error al actualizar línea de negocio',
    UPDATE_SUCCESS: 'Línea de negocio atualizada correctamente',
  },
  GENERAL: {
    UNKNOWN_ERROR: 'Ocurrió un error inesperado',
    CREATE_SUCCESS: 'Creado con éxito',
    CREATE_ERROR: 'Error al crear',
    UPDATE_SUCCESS: 'Actualizado con éxito',
    UPDATE_ERROR: 'Error al actualizar',
    DELETE_SUCCESS: 'Eliminado con éxito',
    DELETE_ERROR: 'Error al eliminar',
    LOAD_SUCCESS: 'Datos cargados con éxito',
    LOAD_ERROR: 'Error al cargar los datos',
    ACTION_SUCCESS: 'Acción realizada con éxito',
    ACTION_ERROR: 'Error al realizar la acción',
    ID_INVALID: 'ID inválido proporcionado',
    NOT_FOUND: 'No se encontró el recurso solicitado',
    FORBIDDEN: 'No tienes permiso para realizar esta acción',
    SESSION_EXPIRED:
      'Tu sesión ha expirado, por favor inicia sesión nuevamente',
    BAD_CONNECTION:
      'Error de conexión. Por favor, verifica tu conexión a internet.',
  },
  AUTH: {
    LOGIN_SUCCESS: 'Inicio de sesión exitoso',
    LOGIN_ERROR: 'Inicio de sesión fallido',
    LOGOUT_SUCCESS: 'Sesión cerrada con éxito',
    LOGOUT_ERROR: 'Error al cerrar la sesión',
    REGISTER_SUCCESS: 'Registro completado con éxito',
    REGISTER_ERROR: 'Error al registrar usuario',
    GET_USER_SUCCESS: 'Datos de usuario obtenidos con éxito',
    GET_USER_ERROR: 'Error al obtener los datos del usuario',
    UNAUTHORIZED: 'Debes iniciar sesión para realizar esta acción',
    PROFILE_ICOMPLETE: 'Debe completar su perfil para realizar esta acción',
    FORBIDDEN:
      'No iniciaste sesión o no tienes permisos para realizar esta acción',
    PROFILE_COMPLETE_SUCCESS: 'Perfil completado con éxito',
    PROFILE_COMPLETE_ERROR: 'Error al completar el perfil',
    PROFILE_INCOMPLETE_WARNING: 'Debes completar tu perfil',
    INVALID_CREDENTIALS: 'Credenciales inválidas',
    ADMIN_NOT_AUTHENTICATED: 'No se ha autenticado la cuenta de administrador',
    ADMIN_NO_ROLE: 'No tienes permisos de administrador',
    ADMIN_LOGIN_SUCCESS: 'Bienvenido al panel de administración',
    RECOVERY_ERROR: 'Error al con el código de recuperación',
    RECOVERY_SUCCESS: 'Se envió un código de recuperación al correo ingresado',
    UPDATE_PASSWORD_SUCCESS: 'Tu contraseña se restableció correctamente',
    RECAPTCHA_ERROR: 'No se pudo validar el reCAPTCHA. Intenta nuevamente.',
    ACCOUNT_NOT_VERIFIED: 'Por favor confirma tu cuenta',
  },
  VALIDATION: {
    REQUIRED: 'Este campo es obligatorio',
    INVALID_EMAIL: 'El correo electrónico no es válido',
    PASSWORD_SHORT: 'La contraseña debe tener al menos 6 caracteres',
    PASSWORD_MISMATCH: 'Las contraseñas no coinciden',
    INVALID_INPUT: 'El valor ingresado no es válido',
  },
  USER: {
    CREATE_SUCCESS: 'Usuario creado con éxito',
    CREATE_ERROR: 'Error al crear usuario',
    UPDATE_SUCCESS: 'Usuario actualizado con éxito',
    UPDATE_ERROR: 'Error al actualizar usuario',
    UPDATE_IMAGE_PROFILE_SUCCESS: 'Imagen de perfil actualizada con éxito',
    UPDATE_IMAGE_PROFILE_ERROR: 'Error al actualizar la imagen de perfil',
    GET_SUCCESS: 'Usuario obtenido con éxito',
    GET_ERROR: 'Error la obtener usuario',
    DELETE_SUCCESS: 'Usuario eliminado con éxito',
    DELETE_ERROR: 'Error al eliminar usuario',
    EXPERIENCE_SUCCES: 'Se creo la experiencia correctamente',
    EXPERIENCE_ERROR: 'Error al crear experiencia',
    EXPERIENCE_UPDATE_SUCCESS: 'Se actualizó experiencia correctamente',
    EXPERIENCE_UPDATE_ERROR: 'Error al actualizar experiencia',
    EXPERIENCE_DELETE_SUCCESS: 'Se elimino experiencia correctamente',
    EXPERIENCE_DELETE_ERROR: 'Error al eliminar experiencia',
    PROFILE_LOAD_ERROR: 'Error al obtener usuario',
    EXPERIENCE_LOAD_ERROR: 'Error al cargar experiencias',
  },
  COMPANY: {
    CREATE_SUCCESS: 'Empresa creada con éxito',
    CREATE_ERROR: 'Error al crear empresa',
    UPDATE_SUCCESS: 'Empresa actualizada con éxito',
    UPDATE_ERROR: 'Error al actualizar empresa',
    UPDATE_LOGO_SUCCESS: 'Logo de empresa actualizado',
    UPDATE_LOGO_ERROR: 'Error al actualizar logo de empresa',
    UPDATE_BANNER_SUCCESS: 'Banner de empresa actualizado',
    UPDATE_BANNER_ERROR: 'Error al actualizar banner de empresa',
    DELETE_SUCCESS: 'Empresa eliminada con éxito',
    DELETE_ERROR: 'Error al eliminar empresa',
    GET_COMPANY_SUCCESS: 'Empresa obtenida con éxito',
    GET_COMPANY_ERROR: 'Error al obtener la empresa',
    GET_ALL_SUCCESS: 'Empresas obtenidas con éxito',
    GET_ALL_ERROR: 'Error al obtener las empresas',
    STASTS_SUCCESS: 'Estadísticas de empresas obtenidas con éxito',
    STASTS_ERROR: 'Error al obtener estadísticas de empresas',
    EMAIL_RESEND_SUCCESS: 'Se reenvió el código a tu correo',
    EMAIL_RESEND_ERROR: 'No se pudo reenviar el código',
    EMAIL_VERIFY_SUCCESS: 'Correo verificado correctamente',
    EMAIL_VERIFY_ERROR: 'El código no es válido',
    BANNER_UPDATE_SUCCESS: 'Banner actualizado con éxito',
    BANNER_UPDATE_ERROR: 'Error al actualizar el banner',
  },
  POSTULANT: {
    APPLY_SUCCESS: 'Tu postulación fue enviada exitosamente.',
    APPLY_WARNING_ME: 'No puedes postular a tu propio empleo.',
    APPLY_ERROR: 'Error al enviar tu postulación.',
    CANCEL_SUCCESS: 'Has cancelado tu postulación con éxito.',
    CANCEL_ERROR: 'Error al cancelar tu postulación.',
    GET_SUCCESS: 'Postulante obtenido',
    GET_ERROR: 'Error al obtener postulante',
    GET_ALL_SUCCESS: 'Postulantes obtenidos con éxito',
    GET_ALL_ERROR: 'Error al obtener los postulantes',
    UPDATE_POSTULANT_JOB_ERROR: 'Error al realizar actualizar postulación',
  },
  EDUCATION: {
    GET_ALL_SUCCESS: 'Educaciones obtenidas con éxito',
    GET_ALL_ERROR: 'Error al obtener las educaciones',
    GET_SUCCESS: 'Educación obtenida con éxito',
    GET_ERROR: 'Error al obtener la educación',
    CREATE_SUCCESS: 'Educación creada con éxito',
    CREATE_ERROR: 'Error al crear la educación',
    UPDATE_SUCCESS: 'Educación actualizada con éxito',
    UPDATE_ERROR: 'Error al actualizar la educación',
    DELETE_SUCCESS: 'Educación eliminada con éxito',
    DELETE_ERROR: 'Error al eliminar la educación',
  },
  DEPARTAMENT: {
    GET_ALL_SUCCESS: 'Departamentos obtenidos con éxito',
    GET_ALL_ERROR: 'Error al obtener los departamentos',
    GET_SUCCESS: 'Departamento obtenido con éxito',
    GET_ERROR: 'Error al obtener el departamento',
    CREATE_SUCCESS: 'Departamento creado con éxito',
    CREATE_ERROR: 'Error al crear el departamento',
    UPDATE_SUCCESS: 'Departamento actualizado con éxito',
    UPDATE_ERROR: 'Error al actualizar el departamento',
    DELETE_SUCCESS: 'Departamento eliminado con éxito',
    DELETE_ERROR: 'Error al eliminar el departamento',
  },
  AREA: {
    GET_ALL_SUCCESS: 'Áreas obtenidas con éxito',
    GET_ALL_ERROR: 'Error al obtener las áreas',
    GET_SUCCESS: 'Área obtenida con éxito',
    GET_ERROR: 'Error al obtener el área',
    CREATE_SUCCESS: 'Área creada con éxito',
    CREATE_ERROR: 'Error al crear el área',
    UPDATE_SUCCESS: 'Área actualizada con éxito',
    UPDATE_ERROR: 'Error al actualizar el área',
    DELETE_SUCCESS: 'Área eliminada con éxito',
    DELETE_ERROR: 'Error al eliminar el área',
  },
  JOB_TYPE: {
    GET_ALL_SUCCESS: 'Tipos de empleo obtenidos con éxito',
    GET_ALL_ERROR: 'Error al obtener los tipos de empleo',
  },
  JOB_TITLE: {
    GET_ALL_SUCCESS: 'Títulos de empleo obtenidos con éxito',
    GET_ALL_ERROR: 'Error al obtener los títulos de empleo',
    GET_SUCCESS: 'Título de empleo obtenido con éxito',
    GET_ERROR: 'Error al obtener el título de empleo',
    CREATE_SUCCESS: 'Título de empleo creado con éxito',
    CREATE_ERROR: 'Error al crear el título de empleo',
    UPDATE_SUCCESS: 'Título de empleo actualizado con éxito',
    UPDATE_ERROR: 'Error al actualizar el título de empleo',
    DELETE_SUCCESS: 'Título de empleo eliminado con éxito',
    DELETE_ERROR: 'Error al eliminar el título de empleo',
  },
  PROFESSION: {
    GET_ALL_SUCCESS: 'Profesiones obtenidas con éxito',
    GET_ALL_ERROR: 'Error al obtener las profesiones',
    GET_SUCCESS: 'Profesión obtenida con éxito',
    GET_ERROR: 'Error al obtener la profesión',
    CREATE_SUCCESS: 'Profesión creada con éxito',
    CREATE_ERROR: 'Error al crear la profesión',
    UPDATE_SUCCESS: 'Profesión actualizada con éxito',
    UPDATE_ERROR: 'Error al actualizar la profesión',
    DELETE_SUCCESS: 'Profesión eliminada con éxito',
    DELETE_ERROR: 'Error al eliminar la profesión',
  },
  PROVINCE: {
    GET_ALL_SUCCESS: 'Provincias obtenidas con éxito',
    GET_ALL_ERROR: 'Error al obtener las provincias',
    GET_SUCCESS: 'Provincia obtenida con éxito',
    GET_ERROR: 'Error al obtener la provincia',
    CREATE_SUCCESS: 'Provincia creada con éxito',
    CREATE_ERROR: 'Error al crear la provincia',
    UPDATE_SUCCESS: 'Provincia actualizada con éxito',
    UPDATE_ERROR: 'Error al actualizar la provincia',
    DELETE_SUCCESS: 'Provincia eliminada con éxito',
    DELETE_ERROR: 'Error al eliminar la provincia',
  },
  DISTRICT: {
    GET_ALL_SUCCESS: 'Distritos obtenidos con éxito',
    GET_ALL_ERROR: 'Error al obtener los distritos',
    GET_SUCCESS: 'Distrito obtenido con éxito',
    GET_ERROR: 'Error al obtener el distrito',
    CREATE_SUCCESS: 'Distrito creado con éxito',
    CREATE_ERROR: 'Error al crear el distrito',
    UPDATE_SUCCESS: 'Distrito actualizado con éxito',
    UPDATE_ERROR: 'Error al actualizar el distrito',
    DELETE_SUCCESS: 'Distrito eliminado con éxito',
    DELETE_ERROR: 'Error al eliminar el distrito',
  },
  EDUCATION_DEGREE: {
    GET_ALL_SUCCESS: 'Grados de educación obtenidos con éxito',
    GET_ALL_ERROR: 'Error al obtener los grados de educación',
    GET_SUCCESS: 'Grado de educación obtenido con éxito',
    GET_ERROR: 'Error al obtener el grado de educación',
    CREATE_SUCCESS: 'Grado de educación creado con éxito',
    CREATE_ERROR: 'Error al crear el grado de educación',
    UPDATE_SUCCESS: 'Grado de educación actualizado con éxito',
    UPDATE_ERROR: 'Error al actualizar el grado de educación',
    DELETE_SUCCESS: 'Grado de educación eliminado con éxito',
    DELETE_ERROR: 'Error al eliminar el grado de educación',
  },
  BUSSINES_LINE: {
    GET_ALL_SUCCESS: 'Lineas de negocio obtenidos con éxito',
    GET_ALL_ERROR: 'Error al obtener los lineas de negocio',
  },
  LANDING: {
    GET_DATA_SUCCESS: 'Datos obtenidos correctamente',
    GET_DATA_ERROR: 'Error al obtener datos',
  },
  SEARCH: {
    GET_RESULTS_SUCCESS: 'Busqueda obtenida con éxito',
    GET_RESULTS_ERROR: 'Error de búsqueda',
  },
};
